<template>
  <div class="row">
    <div class="col-sm-12">
      <div
        id="drop-area"
        class="text-center borderDashed rounded justify-content-center align-items-center modspec_font10"
        style="min-height: 100px; cursor: pointer"
        v-bind="getRootProps()"
      >
        <input v-bind="getInputProps()" />
        <p style="margin-top:2.5rem !important" class="modspec_font12">
          <i class="bi bi-cloud-arrow-up-fill"></i> Drop files here to upload,
          or click <u @click="open">Upload</u>
        </p>
        <br/>
        <ul v-if="names.length > 0" class="list-group mb-2">
          <li class="list-group-item" v-for="name in names" :key="name.name">
            <i class="bi bi-collection me-1 text-primary"></i> {{ name }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { useDropzone } from "vue3-dropzone";

import { ref } from "vue";

export default {
  name: "UseDropzoneDemo",

  setup(props, context) {
    const names = ref(0);

    const saveFiles = (files) => {
      names.value = [];
      const filees = [];
      for (var x = 0; x < files.length; x++) {
        //formData.append("file[]", files[x]);
        filees.push(files[x]);
        names.value.push(files[x].name);
      }
      context.emit("setFiles", filees);

      return names;
    };

    function onDrop(acceptFiles, rejectReasons) {
      let a = saveFiles(acceptFiles); // saveFiles as callback
      console.log("AAAA", a);
      //https://stackoverflow.com/questions/75503666/how-to-show-variable-inside-function-in-vue3-template
      console.log(rejectReasons);
    }

    const { getRootProps, getInputProps, ...rest } = useDropzone({ onDrop });

    return {
      getRootProps,
      getInputProps,
      names,
      ...rest,
    };
  },
};
</script>
<style scoped>
.borderDashed {
  border: 2px dashed #212529;
}
</style>
